import cssJoin from '../cssJoin';
/**
 * Returns a function that adds given css prefixes to strings.
 *
 * @param prefixes Prefix values.
 */
export const cssPrefix = (...prefixes) => (...values) =>
  cssJoin(...prefixes, ...values);
export default cssPrefix;
